import axios from "axios";

export const searchApi = axios.create({
  baseURL: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
  params:{
    limit: 5,
    language: 'es',
    access_token: 'pk.eyJ1IjoiZ2Fib2dhYml0byIsImEiOiJja25ybGducnYwampjMzFvMzJtM3BhZ3lsIn0._JfEmngPETXvFd8KvgOdxg'
  }
})

export default searchApi;